import { StaffPermission, usePermission } from "@hooks/usePermission";

import { VendorApplicationStatus } from "../constant";

// 有 VENDOR_FINANCE_APPROVAL 權限時可編輯的狀態
const FINANCE_EDITABLE_STATUSES: number[] = [
  VendorApplicationStatus.MANAGER_REJECTED,
  VendorApplicationStatus.PENDING_FILING,
  VendorApplicationStatus.FINANCE_REJECTED,
  VendorApplicationStatus.PENDING_SYNC,
  VendorApplicationStatus.COMPLETED,
];
// 無 VENDOR_FINANCE_APPROVAL 權限時，僅這些狀態可編輯
const STAFF_EDITABLE_STATUSES: number[] = [VendorApplicationStatus.MANAGER_REJECTED];

/** 回傳判斷廠商基本資料是否可編輯的函式，依登入者的財務／主管權限決定 */
export default function useVendorBasicEditPermission() {
  const hasFinanceApproval = usePermission(StaffPermission.VENDOR_FINANCE_APPROVAL);
  const editableStatuses = hasFinanceApproval ? FINANCE_EDITABLE_STATUSES : STAFF_EDITABLE_STATUSES;
  // 主管不能編輯基本資料
  const isManager = usePermission(StaffPermission.VENDOR_MANAGER_APPROVAL);

  const canEditBasicStatus = (applicationStatus: number) =>
    editableStatuses.includes(applicationStatus) && !isManager;

  return { canEditBasicStatus };
}
